module.exports = __webpack_public_path__ + "static/media/iconStudentGirls.50dcdaa6.svg";